import { render, staticRenderFns } from "./equipmentType.vue?vue&type=template&id=70c2425a&scoped=true&"
import script from "./equipmentType.vue?vue&type=script&lang=js&"
export * from "./equipmentType.vue?vue&type=script&lang=js&"
import style0 from "./equipmentType.vue?vue&type=style&index=0&id=70c2425a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2425a",
  null
  
)

export default component.exports